<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="werks" style="margin-bottom: 0;">
                        <span v-if="viewFlag === 'view'">{{dataForm.name2}}</span>
                        <el-select v-else v-model="dataForm.werks" filterable placeholder="请选择工厂" @change="setFactoryName">
                            <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料编码:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="matnr">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.matnr" placeholder="物料编码" size="small"></el-input>
                        <span v-else>{{dataForm.matnr}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料描述:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="maktx">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.maktx" placeholder="物料描述" size="small"></el-input>
                        <span v-else>{{dataForm.maktx}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="M+1数量:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="zmenge11">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.zmenge11" placeholder="M+1数量" size="small"></el-input>
                        <span v-else>{{dataForm.zmenge11}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="M+2数量:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="zmenge22">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.zmenge22" placeholder="M+2数量" size="small"></el-input>
                        <span v-else>{{dataForm.zmenge22}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="M+3数量:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="zmenge33">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.zmenge33" placeholder="M+3数量" size="small"></el-input>
                        <span v-else>{{dataForm.zmenge33}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="计划期间:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="perxx">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.perxx" placeholder="计划期间" size="small"></el-input>
                        <span v-else>{{dataForm.perxx}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="发布日期:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="zfbrq">
                        <el-date-picker v-if="viewFlag !== 'view'" v-model="dataForm.zfbrq" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                        </el-date-picker>
                        <span v-else>{{dataForm.zfbrq}}</span>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>

        <el-row :gutter="40">
            <el-col :span="24" style="text-align:right;">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()" :loading="loading">
                    保存
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</el-dialog>
</template>

<script>
import {
    editCarForecast,
    createCarForecast,
    getCarForecastById,
} from '@/controller/sap'
import {
    getFactoryList,
} from '@/controller/systemData'
import moment from 'moment'
// require('@/mock/mockProject');
export default {
    data() {
        return {
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            factoryList: [],
            dataForm: {
                perxx: '',
                werks: '',
                name2: '',
                matnr: '',
                maktx: '',
                zmenge11: '',
                zmenge22: '',
                zmenge33: '',
                zfbrq: '',
            },
            dataRule: {
                // projectManagerId: [{
                //     required: true,
                //     message: '项目负责人名称不能为空',
                //     // trigger: 'blur'
                // }],
                // code: [{
                //     required: true,
                //     message: '组织代码不能为空',
                //     trigger: 'blur'
                // }],
                // tenantName: [{
                //     required: true,
                //     message: '请先在页面顶部导航栏选择租户',
                //     trigger: 'blur'
                // }]
            }
        }
    },
    mounted() {},
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getCarForecastById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                            this.dataForm.zfbrq = moment(this.dataForm.zfbrq).format("yyyy-MM-DD HH:mm:ss")
                        }
                    });
                }
                this.getFactoryList()
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 1000)
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    if (this.dataForm.id) {
                        editCarForecast(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createCarForecast(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.factoryDesc = ""
            })
        },
        setFactoryName(val) {
            console.log(val)
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.name2 = factory ? factory.factoryDesc : ''
        },
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            return 'width: 425.5px;'
        }
    },
}
</script>